import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BannerPosition, BannerVariant } from './banner.component';

export interface BannerConfig {
  variant: BannerVariant;
  message: string;
  title?: string;
  detailText?: string;
  position?: BannerPosition;
  topOffset?: string;
  iconName?: string;
  showSpinner?: boolean;
  showClose?: boolean;
}

@Injectable({ providedIn: 'root' })
export class BannerService {
  private readonly bannerSubject = new BehaviorSubject<
    BannerConfig | undefined
  >(undefined);

  readonly banner$ = this.bannerSubject.asObservable();

  show(config: BannerConfig): void {
    this.bannerSubject.next(config);
  }

  success(
    message: string,
    title?: string,
    options?: Partial<BannerConfig>,
  ): void {
    this.show({ ...options, variant: 'success', message, title });
  }

  warning(
    message: string,
    title?: string,
    options?: Partial<BannerConfig>,
  ): void {
    this.show({ ...options, variant: 'warning', message, title });
  }

  error(
    message: string,
    title?: string,
    options?: Partial<BannerConfig>,
  ): void {
    this.show({ ...options, variant: 'error', message, title });
  }

  info(message: string, title?: string, options?: Partial<BannerConfig>): void {
    this.show({ ...options, variant: 'info', message, title });
  }

  close(): void {
    this.bannerSubject.next(undefined);
  }
}
